export const NAVIGATION_ACTION_TYPES = {
    SET_SIDEBAR_MODE: 'navigation/SET_SIDEBAR_MODE',
    SET_SIDEBAR_ACTIVE: 'navigation/SET_SIDEBAR_ACTIVE',
    SET_THEME_MENU_ACTIVE: 'navigation/SET_THEME_MENU_ACTIVE',
};
